import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#06BDE9',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#eb3031',
        success: '#36c135',
      },
    },
  },
  icons: {
    values: {
      chart: {
        component: () => import('@/components/icons/IconChart'),
      },
      heart: {
        component: () => import('@/components/icons/IconHeart'),
      },
      'heart-active': {
        component: () => import('@/components/icons/IconHeart'),
        props: {
          isActive: true,
        },
      },
      'heart-full': {
        component: () => import('@/components/icons/IconHeartFull'),
      },
      card: {
        component: () => import('@/components/icons/IconCards'),
      },
      'card-active': {
        component: () => import('@/components/icons/IconCards'),
        props: {
          isActive: true,
        },
      },
      'card-info-dialog': {
        component: () => import('@/components/icons/IconCardInfoDialog'),
      },
      'card-block': {
        component: () => import('@/components/icons/IconCardBlock'),
      },
      'card-unblock': {
        component: () => import('@/components/icons/IconCardUnblock'),
      },
      'deposit-active': {
        component: () => import('@/components/icons/IconActiveDeposit'),
      },
      'deposit-deactive': {
        component: () => import('@/components/icons/IconDeactiveDeposit'),
      },
      'pin-change': {
        component: () => import('@/components/icons/IconPinChange'),
      },
      copy: {
        component: () => import('@/components/icons/IconCopy'),
      },
      'copy-white': {
        component: () => import('@/components/icons/IconCopyWhite'),
      },
      eye: {
        component: () => import('@/components/icons/IconEye'),
      },
      automobile: {
        component: () => import('@/components/icons/IconAutomobile'),
      },
      'automobile-list-item': {
        component: () => import('@/components/icons/IconAutomobileList'),
      },
      'percent-warning': {
        component: () => import('@/components/icons/IconPercentWarning'),
      },
      'automobile-modal': {
        component: () => import('@/components/icons/IconAutomobileModal'),
      },
      clock: {
        component: () => import('@/components/icons/IconClock'),
      },
      'uber-icon': {
        component: () => import('@/components/icons/IconUber'),
      },
      'transfer-user-balance': {
        component: () => import('@/components/icons/IconBalanceTransfer'),
      },
      user: {
        component: () => import('@/components/icons/IconUser'),
      },
      'transfer-slider-prev': {
        component: () => import('@/components/icons/IconTransferSliderPrev'),
      },
      'transfer-slider-next': {
        component: () => import('@/components/icons/IconTransferSliderNext'),
      },
      'animation-sad': {
        component: () => import('@/components/icons/AnimationSad'),
      },
      'transfer-credit-card': {
        component: () => import('@/components/icons/IconCreditCardTransfer'),
      },
      'transfer-card-icon': {
        component: () => import('@/components/icons/IconTransferCard'),
      },
      'transfer-wallet-icon': {
        component: () => import('@/components/icons/IconTransferWallet'),
      },
      'credit-card': {
        component: () => import('@/components/icons/IconCreditCard'),
      },
      'credit-card-active': {
        component: () => import('@/components/icons/IconCreditCard'),
        props: {
          isActive: true,
        },
      },
      wallet: {
        component: () => import('@/components/icons/IconWallet'),
      },
      'wallet-active': {
        component: () => import('@/components/icons/IconWallet'),
        props: {
          isActive: true,
        },
      },
      transfer: {
        component: () => import('@/components/icons/IconTransfer'),
      },
      'coupon-blue': {
        component: () => import('@/components/icons/IconBlueCoupon'),
      },
      'coupon-green': {
        component: () => import('@/components/icons/IconGreenCoupon'),
      },
      'coupon-red': {
        component: () => import('@/components/icons/IconRedCoupon'),
      },
      stat: {
        component: () => import('@/components/icons/IconStat'),
      },
      support: {
        component: () => import('@/components/icons/IconSupport'),
      },
      cog: {
        component: () => import('@/components/icons/IconCog'),
      },
      edit: {
        component: () => import('@/components/icons/IconEdit'),
      },
      warning: {
        component: () => import('@/components/icons/IconWarning'),
      },
      delete: {
        component: () => import('@/components/icons/IconDelete'),
      },
      'delete-active': {
        component: () => import('@/components/icons/IconDelete'),
        props: {
          isActive: true,
        },
      },
      'favorite-place': {
        component: () => import('@/components/icons/IconFavoritePlace'),
      },
      wishlist: {
        component: () => import('@/components/icons/IconWishlist'),
      },
      'autoPayment-place': {
        component: () => import('@/components/icons/IconAutoPaymentPlace'),
      },
      'favorite-star': {
        component: () => import('@/components/icons/IconFavoriteStar'),
      },
      'favorite-star-2': {
        component: () => import('@/components/icons/IconFavoriteStar2'),
      },
      'plus-mobile': {
        component: () => import('@/components/icons/IconPlusMobile'),
      },
      'create-favorite-payment': {
        component: () => import('@/components/icons/IconCreateFavoritePayment'),
      },
      'create-favorite-transfer': {
        component: () => import('@/components/icons/IconCreateFavoriteTransfer'),
      },
      'create-favorite-arrow': {
        component: () => import('@/components/icons/IconCreateFavoriteRightArrow'),
      },
      'right-arrow': {
        component: () => import('@/components/icons/IconRightArrow'),
      },
      'right-arrow-active': {
        component: () => import('@/components/icons/IconRightArrow'),
        props: {
          isActive: true,
        },
      },
      'arrow-up-right': {
        component: () => import('@/components/icons/IconArrowUpRight'),
      },
      'arrow-down-left': {
        component: () => import('@/components/icons/IconArrowDownLeft'),
      },
      'right-arrow-two': {
        component: () => import('@/components/icons/IconRightArrowTwo'),
      },
      bell: {
        component: () => import('@/components/icons/IconBell'),
      },
      'bell-active': {
        component: () => import('@/components/icons/IconBell'),
        props: {
          isActive: true,
        },
      },
      lock: {
        component: () => import('@/components/icons/IconLock'),
      },
      'lock-dot': {
        component: () => import('@/components/icons/IconLockDot'),
      },
      'lock-active': {
        component: () => import('@/components/icons/IconLock'),
        props: {
          isActive: true,
        },
      },
      'lock-blue': {
        component: () => import('@/components/icons/IconLockBlue'),
      },
      'lock-reset': {
        component: () => import('@/components/icons/IconLockReset'),
      },
      files: {
        component: () => import('@/components/icons/IconFiles'),
      },
      'files-active': {
        component: () => import('@/components/icons/IconFiles'),
        props: {
          isActive: true,
        },
      },
      file: {
        component: () => import('@/components/icons/IconFile'),
      },
      docs: {
        component: () => import('@/components/icons/IconDocs'),
      },
      privacy: {
        component: () => import('@/components/icons/IconPrivacy'),
      },
      'shield-off': {
        component: () => import('@/components/icons/IconShieldOff'),
      },
      'deposit-off': {
        component: () => import('@/components/icons/IconDepositOff'),
      },
      'deposit-on': {
        component: () => import('@/components/icons/IconDepositOn'),
      },
      'line-chart-down': {
        component: () => import('@/components/icons/IconLineChartDown'),
      },
      'slash-circle': {
        component: () => import('@/components/icons/IconSlashCircle'),
      },
      percent: {
        component: () => import('@/components/icons/IconPercent'),
      },
      logout: {
        component: () => import('@/components/icons/IconLogout'),
      },
      logoutRed: {
        component: () => import('@/components/icons/IconLogoutRed'),
      },
      'logout-modal': {
        component: () => import('@/components/icons/IconLogoutModal'),
      },
      'check-circle-gray': {
        component: () => import('@/components/icons/IconCheckCircleGray'),
      },
      'check-circle-green': {
        component: () => import('@/components/icons/IconCheckCircleGreen'),
      },
      'check-tooltip': {
        component: () => import('@/components/icons/IconCheckTooltip'),
      },
      'check-full': {
        component: () => import('@/components/icons/IconCheckSettingsPage'),
      },
      persons: {
        component: () => import('@/components/icons/IconPersons'),
      },
      'persons-active': {
        component: () => import('@/components/icons/IconPersons'),
        props: {
          isActive: true,
        },
      },
      language: {
        component: () => import('@/components/icons/IconLanguage'),
      },
      'language-active': {
        component: () => import('@/components/icons/IconLanguage'),
        props: {
          isActive: true,
        },
      },
      'visa-card': {
        component: () => import('@/components/icons/IconVisa'),
      },
      'visa-white-card': {
        component: () => import('@/components/icons/IconVisaWhite'),
      },
      'master-card': {
        component: () => import('@/components/icons/IconMastercard'),
      },
      'edit-card': {
        component: () => import('@/components/icons/IconEditCard'),
      },
      'edit-card-active': {
        component: () => import('@/components/icons/IconEditCard'),
        props: {
          isActive: true,
        },
      },
      retry: {
        component: () => import('@/components/icons/IconRetry'),
      },
      notification: {
        component: () => import('@/components/icons/IconNotification'),
      },
      'filter-empty': {
        component: () => import('@/components/icons/IconFilterEmpty'),
      },
      'notification-empty': {
        component: () => import('@/components/icons/IconNotificationEmpty'),
      },
      notificationunread: {
        component: () => import('@/components/icons/IconNotificationUnread'),
      },
      readall: {
        component: () => import('@/components/icons/IconReadAll'),
      },
      settings: {
        component: () => import('@/components/icons/IconSettings'),
      },
      regulators: {
        component: () => import('@/components/icons/IconRegulators'),
      },
      send: {
        component: () => import('@/components/icons/IconSend'),
      },
      refresh: {
        component: () => import('@/components/icons/IconRefresh'),
      },
      'refresh-active': {
        component: () => import('@/components/icons/IconRefresh'),
        props: {
          isActive: true,
        },
      },
      download: {
        component: () => import('@/components/icons/IconDownload'),
      },
      'download-grey': {
        component: () => import('@/components/icons/IconDownloadGrey'),
      },
      'download-file': {
        component: () => import('@/components/icons/IconDownloadFile'),
        props: {
          isActive: true,
        },
      },
      'download-circle': {
        component: () => import('@/components/icons/IconDownloadCircle'),
      },
      'extract-file': {
        component: () => import('@/components/icons/IconExtractFile'),
      },
      'blue-file': {
        component: () => import('@/components/icons/IconFileBlue'),
      },
      'hide-password': {
        component: () => import('@/components/icons/IconHidePassword'),
      },
      'show-password': {
        component: () => import('@/components/icons/IconShowPassword'),
      },
      'show-password-active': {
        component: () => import('@/components/icons/IconShowPassword'),
        props: {
          isActive: true,
        },
      },
      profile: {
        component: () => import('@/components/icons/IconProfile'),
      },
      info: {
        component: () => import('@/components/icons/IconInfo'),
      },
      'blue-info': {
        component: () => import('@/components/icons/IconInfoCircleBlue'),
      },
      'favorites-info': {
        component: () => import('@/components/icons/IconFavoritesInfo'),
      },
      search: {
        component: () => import('@/components/icons/IconSearch'),
      },
      'category-search': {
        component: () => import('@/components/icons/IconCategorySearch'),
      },
      'no-result-found': {
        component: () => import('@/components/icons/IconNotFound'),
      },
      close: {
        component: () => import('@/components/icons/IconClose'),
      },
      'search-close': {
        component: () => import('@/components/icons/IconSearchClose'),
      },
      up: {
        component: () => import('@/components/icons/IconUp'),
      },
      'up-right': {
        component: () => import('@/components/icons/IconUpRight'),
      },
      messenger: {
        component: () => import('@/components/icons/IconMessenger'),
      },
      'share-messenger': {
        component: () => import('@/components/icons/IconShareMessenger'),
      },
      whatsapp: {
        component: () => import('@/components/icons/IconWhatsapp'),
      },
      'share-whatsapp': {
        component: () => import('@/components/icons/IconShareWhatsapp'),
      },
      'share-telegram': {
        component: () => import('@/components/icons/IconShareTelegram'),
      },
      phone: {
        component: () => import('@/components/icons/IconPhone'),
      },
      mail: {
        component: () => import('@/components/icons/IconMail'),
      },
      'call-center': {
        component: () => import('@/components/icons/IconCallCenter'),
      },
      call: {
        component: () => import('@/components/icons/IconCall'),
      },
      'share-mail': {
        component: () => import('@/components/icons/IconShareMail'),
      },
      location: {
        component: () => import('@/components/icons/IconLocation'),
      },
      'gift-ready': {
        component: () => import('@/components/icons/IconGiftReady'),
      },
      'gift-pending': {
        component: () => import('@/components/icons/IconGiftPending'),
      },
      'gift-reverse': {
        component: () => import('@/components/icons/IconGiftReverse'),
      },
      'gift-success': {
        component: () => import('@/components/icons/IconGiftSuccess'),
      },
      'gift-error': {
        component: () => import('@/components/icons/IconGiftError'),
      },
      'coupon-wallet': {
        component: () => import('@/components/icons/IconCouponWallet'),
      },
      'coupon-empty': {
        component: () => import('@/components/icons/IconCouponEmpty'),
      },
      'coupon-info-circle': {
        component: () => import('@/components/icons/IconCouponInfoCircle'),
      },
      'coupon-check-circle': {
        component: () => import('@/components/icons/IconCheckCircle'),
      },
      coupon: {
        component: () => import('@/components/icons/IconCoupon'),
      },
      terminal: {
        component: () => import('@/components/icons/IconTerminal'),
      },
      error: {
        component: () => import('@/components/icons/IconError'),
      },
      'error-empty': {
        component: () => import('@/components/icons/IconEmptyError'),
      },
      'error-receipt': {
        component: () => import('@/components/icons/IconErrorReceipt'),
      },
      warn: {
        component: () => import('@/components/icons/IconWarn'),
      },
      calendar: {
        component: () => import('@/components/icons/IconCalendar'),
      },
      time: {
        component: () => import('@/components/icons/IconCalendar'),
      },
      back: {
        component: () => import('@/components/icons/IconGoBack'),
      },
      down: {
        component: () => import('@/components/icons/IconDownChevron'),
      },
      right: {
        component: () => import('@/components/icons/IconRightChevron'),
      },
      plus: {
        component: () => import('@/components/icons/IconPlus'),
      },
      'circle-plus': {
        component: () => import('@/components/icons/IconCirclePlus'),
      },
      filter: {
        component: () => import('@/components/icons/IconFilter'),
      },
      'dark-filter': {
        component: () => import('@/components/icons/IconDarkFilter'),
      },
      'filter-mobile': {
        component: () => import('@/components/icons/IconFilterMobile'),
      },
      'default-logo': {
        component: () => import('@/components/icons/IconDefaultLogo'),
      },
      autopayment: {
        component: () => import('@/components/icons/IconAutopayment'),
      },
      'autopayment-not-valid': {
        component: () => import('@/components/icons/IconAutopaymentNotValid'),
      },
      commision: {
        component: () => import('@/components/icons/IconCommisionSymbal'),
      },
      'not-commision': {
        component: () => import('@/components/icons/IconCommisionSymbal'),
        props: {
          isActive: true,
        },
      },
      success: {
        component: () => import('@/components/icons/IconSuccess'),
      },
      facebook: {
        component: () => import('@/components/icons/IconFacebook'),
      },
      instagram: {
        component: () => import('@/components/icons/IconInstagram'),
      },
      'app-qr': {
        component: () => import('@/components/icons/IconAppQR'),
      },
      'info-warning': {
        component: () => import('@/components/icons/IconInfoWarning'),
      },
      'info-warning-gray': {
        component: () => import('@/components/icons/IconInfoWarningGray'),
      },
      tick: {
        component: () => import('@/components/icons/IconTick'),
      },
      'sima-logo': {
        component: () => import('@/components/icons/IconSimaLogo'),
      },
      'mpay-logo': {
        component: () => import('@/components/icons/IconMpayLogo'),
      },
      'transaction-reverse': {
        component: () => import('@/components/icons/IconTransactionReverse'),
      },
      'sima-verification-logo': {
        component: () => import('@/components/icons/IconSimaVerificationLogo'),
      },
    },
  },
});
